import { toastError } from '@components/Toast';

import { likeProduct } from '@store/design/action';
import { getSearchResult } from '@store/searchOptions/actions';
import { Types } from '@store/types';

import ApiClient, { routes } from '@lib/apiClient';

export const storeInitialItemInGlobalFilter = (data) => async (dispatch) => {
	dispatch({
		type: Types.STORE_INITIAL_ITEM_IN_GLOBAL_FILTER,
		payload: data
	});
};

export const storeItemInGlobalFilter = (data) => async (dispatch) => {
	let { name, value } = data;
	if (value && name) {
		dispatch({
			type: Types.STORE_ITEM_IN_GLOBAL_FILTER,
			payload: data
		});
	}
};

export const updateTextItemInGlobalFilter = (data) => async (dispatch) => {
	let { name } = data;
	if (name) {
		dispatch({
			type: Types.UPDATE_TEXT_ITEM_IN_GLOBAL_FILTER,
			payload: data
		});
	}
};
export const updateTextItemMultipleInGlobalFilter = (data) => async (dispatch) => {
	let { name } = data;
	if (name && data?.list?.length) {
		dispatch({
			type: Types.UPDATE_TEXT_ITEM_MULTIPLE_IN_GLOBAL_FILTER,
			payload: data
		});
	}
};

export const removeItemFromGlobalFilter = (data) => {
	return {
		type: Types.REMOVE_ITEM_FROM_GLOBAL_FILTER,
		payload: data
	};
};

export const clearGlobalFilter = () => async (dispatch) => {
	dispatch({
		type: Types.CLEAR_GLOBAL_FILTER,
		payload: {}
	});
};
export const clearGlobalFilterWithExcludeField = (data) => async (dispatch) => {
	dispatch({
		type: Types.CLEAR_GLOBAL_FILTER_WITH_EXCLUDE,
		payload: data
	});
};
export const clearGlobalFilterWithDateField = (data) => async (dispatch) => {
	dispatch({
		type: Types.CLEAR_GLOBAL_FILTER_WITH_DATE,
		payload: data
	});
};

export const clearGlobalFilterWithSelectedFields = (data) => async (dispatch) => {
	dispatch({
		type: Types.CLEAR_GLOBAL_FILTER_SELECTED_FIELDS,
		payload: data
	});
};

export const clearFilterResponse = () => async (dispatch) => {
	dispatch({
		type: Types.CLEAR_GLOBAL_FILTER_RESPONSE,
		payload: {}
	});
};

export const fetchFilterData = (data, merge) => {
	return {
		type: Types.FETCH_GLOBAL_FILTER_DATA,
		payload: { ...data, merge: merge }
	};
};

export const addItemInGlobalFilterData = (data) => {
	return {
		type: Types.ADD_ITEM_IN_GLOBAL_FILTER_DATA,
		payload: data
	};
};

export const updateGlobalFilterData = (data) => {
	return {
		type: Types.UPDATE_GLOBAL_FILTER_DATA,
		payload: data
	};
};

export const handleFilter =
	(url, params, merge, requestType = 'GET', requestBody = {}, isViewTechPack, isAddFev) =>
	async (dispatch) => {
		try {
			const { data } =
				requestType === 'GET'
					? await ApiClient.GET(url, params)
					: await ApiClient.POST(url, requestBody, params);

			dispatch(
				fetchFilterData(
					{
						...data,
						isCollectionListTab: url === 'getCollectionList',
						isDesingnListTab: url === 'getManageProducts',
						isArtwork: url === 'getAllArtWork',
						isSketch: url === 'getAllSkectch',
						isBlockLibrary: url === 'getAllProductBlock'
					},
					merge
				)
			);
			if (isViewTechPack && data?.data?.length === 1) {
				dispatch(getSearchResult(data?.data[0]?.id));
			}
			if (isAddFev && data?.data?.length === 1) {
				dispatch(likeProduct(data?.data[0]?.id));
			}
		} catch {
			toastError('Something went wrong!');
		}
	};

export const handleFilterOfListPage = (pageType, params, merge) => async (dispatch) => {
	let url = routes[pageType.type];
	if (pageType.idUrl) {
		url += pageType.idUrl;
	}
	await ApiClient.GET(url, params, true)
		.then((response) => {
			dispatch(fetchFilterData(response.data, merge));
		})
		.catch(() => toastError('Something went wrong!'));
};

export const removeItemFromFilterResponse = (id) => {
	return {
		type: Types.REMOVE_ITEM_FROM_FILTER_RESPONSE,
		payload: id
	};
};

export const toggleGlobalFilter = (data) => {
	return {
		type: Types.TOGGLE_GLOBAL_FILTER,
		payload: data
	};
};

export const updateDesignInfo = (designInfo) => {
	return {
		type: Types.UPDATE_DESIGN_INFO_SUCCESS,
		payload: designInfo
	};
};

export const setPinnedCollection = (id) => {
	return {
		type: Types.SET_PINNED_COLLECTION,
		payload: id
	};
};

export const setUnPinnedCollection = (id) => {
	return {
		type: Types.SET_UNPINNED_COLLECTION,
		payload: id
	};
};

export const setHasMentionedId = (id) => {
	return {
		type: Types.SET_HAS_MENTIONED_ID,
		payload: id
	};
};

export const storeSelectedFilterCheckboxType = (data) => async (dispatch) => {
	dispatch({
		type: Types.STORE_SELECTED_FILTER_CHECK_BOX_TYPE,
		payload: data
	});
};

export const storeSelectedCategory = (data) => async (dispatch) => {
	dispatch({
		type: Types.STORE_IN_MULTI_LEVEL_FILTER,
		payload: data
	});
};

export const clearDetailsPageGlobalFilter = () => {
	return {
		type: Types.CLEAR_DETAILS_PAGE_GLOBAL_FILTER
	};
};

export const toggleBlockSuggestionsFilter = (data) => async (dispatch) => {
	dispatch({
		type: Types.TOGGLE_BLOCK_SUGGESTIONS_FILTER,
		payload: data
	});
};

export const clearSelectedFilterName = (data) => async (dispatch) => {
	dispatch({
		type: Types.CLEAR_SELECTED_FILTER_NAME,
		payload: data
	});
};

export const updateMultiLevelFilter = (data) => async (dispatch) => {
	dispatch({
		type: Types.UPDATE_IN_MULTI_LEVEL_FILTER,
		payload: data
	});
};

export const replaceDetailsPageFilterFields = (data) => {
	return {
		type: Types.REPLACE_DETAILS_PAGE_FILTER_FIELDS,
		payload: data
	};
};
